/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseVignette } from '../../models/response-vignette';
import { VignetteForLicenseplatenumbersBody } from '../../models/vignette-for-licenseplatenumbers-body';

export interface Vignettes$Params {

/**
 * customer GUID from svgzapi-core
 */
  customerGUID: string;
      body: VignetteForLicenseplatenumbersBody
}

export function vignettes(http: HttpClient, rootUrl: string, params: Vignettes$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseVignette>> {
  const rb = new RequestBuilder(rootUrl, vignettes.PATH, 'post');
  if (params) {
    rb.query('customerGUID', params.customerGUID, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseVignette>;
    })
  );
}

vignettes.PATH = '/vignetteforlicenseplatenumbers';
